import { RouterProvider } from 'react-router-dom';
import './App.css';
import Main from './Main/Main';
import router from './Routes/Router/Router';

function App() {
  return (
    <RouterProvider router={router}>
      <Main></Main>
    </RouterProvider>
  );
}

export default App;
